<template>
  <div>
    <ModuleHeader>Ventas Producto</ModuleHeader>
    <v-overlay v-if="loadingData">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col md="12" cols="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col md="10" cols="12">
                <v-row>
                  <v-col md="4" cols="6">
                    <v-menu v-model="menuFechaInicial" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="input_date" label="Fecha Inicial" prepend-icon="mdi-calendar" readonly
                          @input="getAperturas()" v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="input_date" @input="
                        menuFechaInicial = false;
                      getAperturas();
                      "></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col md="4" cols="6">
                    <v-menu v-model="menuFechaInicial2" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="input_date_final" label="Fecha Final" prepend-icon="mdi-calendar"
                          @input="getAperturas()" readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="input_date_final" @input="
                        menuFechaInicial2 = false;
                      getAperturas();
                      "></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col md="4" cols="6">
                    <v-autocomplete label="Departamentos" v-model="selectDep" item-text="Nombre" item-value="id"
                      @input="getAperturas()" :items="departamentos"></v-autocomplete>
                  </v-col>
                  <v-col md="4" cols="12" class="mt-n6">
                    <v-autocomplete v-model="input_familias" label="Familias" :items="familiasList" item-value="id"
                      item-text="Nombre">
                    </v-autocomplete>
                  </v-col>
                  <v-col md="4" cols="12" class="mt-n6">
                    <v-autocomplete v-model="input_categoria" label="Categoría del producto" :items="categoriesList"
                      multiple item-value="id" item-text="label">
                    </v-autocomplete>
                  </v-col>
                  <v-col md="4" cols="12" class="mt-n6">
                    <v-autocomplete :items="global_prod" v-model="selectedProducts" multiple item-value="id"
                      item-text="Nombre" label="Productos">
                    </v-autocomplete>
                  </v-col>
                  <v-col md="6" cols="12" class="mt-n6">
                    <v-autocomplete label="Turno" v-model="selectTurno" item-value="Turno" item-text="Desc"
                      :items="turnosList">
                    </v-autocomplete>
                  </v-col>
                  <v-col md="6" cols="12" class="mt-n6">
                    <v-autocomplete label="Meseros" v-model="selectMesero" item-text="Nombre" item-value="id"
                      :items="meserosComp"></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
              <v-col md="2" cols="12">
                <v-radio-group v-model="orderType">
                  <v-radio :label="`Ordenar mas vendidos`" :value="1"></v-radio>
                  <v-radio :label="`Ordenar por categoria`" :value="2"></v-radio>
                  <v-radio :label="`Ordenar alfabéticamente`" :value="3"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col class="text-right mt-n5" md="12" cols="12">
                <v-btn depressed @click="cleanFilter()" class="mx-2" color="error">
                  Restablecer Filtro
                </v-btn>
                <v-btn depressed @click="searchVentas()" color="success">
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col md="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col md="4" cols="12">
                Resultados (La columna precio puede ser variable dependiento de
                modificadores y descuentos)
              </v-col>
              <v-col md="6" cols="12" class="text-right">
                <v-btn @click="generatePdf()" color="red" dark><v-icon>mdi-file-pdf-box</v-icon>
                  Agrupado por Categoria
                </v-btn>
                <v-btn @click="dialogVendidosFecha = true" class="mx-1" color="primary" dark>
                  Vendidos por Fecha
                </v-btn>
                <v-btn v-if="false" @click="generatePdfSaleByDate()" color="red" class="mx-1"
                  dark><v-icon>mdi-file-pdf-box</v-icon>
                  Vendidos por Fecha
                </v-btn>
              </v-col>
              <v-col md="2" cols="6" class="text-right">
                <v-btn color="green" dark @click="exportExcel(0)"><v-icon>mdi-file-excel-box</v-icon>
                  Exportar a Excel
                  <!-- <download-excel
                  type="xls"
                  name="Venta producto"
                  :data="datos.processedData"
                  >
                  </download-excel> -->
                </v-btn>
              </v-col>
              <!-- <v-col md="12" class="mt-n6">
                <v-text-field v-model="filter" label="Filtrar"></v-text-field>
              </v-col> -->
            </v-row>
            <h3>Productos</h3>
            <uv-data-table v-if="render" ref="uvDataTable" :config="config" :data="dataProductos" :pageRows="15"
              @buttonClick="dtButtonClick"></uv-data-table>
            <v-simple-table v-if="false" class="dense-table" dense>
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Familia</th>
                  <th>Categoria</th>
                  <th>Vendidos</th>
                  <th>Modi.</th>
                  <th>Precio (Variable)</th>
                  <th>Total Neto (descuentos incluidos)</th>
                  <th>Detalle de venta</th>
                  <th v-if="showFolios">Folios</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="datos.processedData.length == 0">
                  <td colspan="16">No se encontraron datos</td>
                </tr>
                <template v-for="(prod, index) in dataProductos">
                  <tr :key="index">
                    <td>
                      {{ prod.Id == "Reserva" ? "TEE TIMES" : prod.Nombre }}
                    </td>
                    <td>{{ prod.FamiliaName }}</td>
                    <td>{{ prod.CategoriaName }}</td>
                    <td>
                      <b>{{ prod.Vendidos }}</b>
                    </td>
                    <td>
                      {{ prod.ModificadoresAplicados }}
                    </td>
                    <td>
                      <b>{{ $pgsHelper.formatNumber(prod.Precio) }}</b>
                    </td>

                    <td>
                      <b>{{ $pgsHelper.formatNumber(prod.Total) }}</b>
                    </td>
                    <td>
                      <v-btn small @click="showDetailVenta(prod.Id)" color="success">Detalle de venta</v-btn>
                    </td>
                    <td v-if="showFolios">
                      <b>{{ prod.Tickets }}</b>
                    </td>
                  </tr>
                </template>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="detalleVentaToogle" max-width="850">
      <v-card>
        <v-card-title class="text-h5">
          Detalles de venta por producto
          <v-btn color="green" dark @click="exportExcel(1)"><v-icon>mdi-file-excel-box</v-icon>
            Exportar detalle Excel
            <!-- <download-excel
              type="xls"
              name="Detalle de venta producto"
              :data="detalleVenta"
            >
            </download-excel> -->
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-simple-table class="dense-table" dense>
            <thead>
              <tr>
                <th>Folio</th>
                <th>Fecha</th>
                <th>Cliente</th>
                <th>Cantidad</th>
                <th>Nombre</th>
                <th>Total</th>
                <th>Moneda</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="detalleVenta.length == 0">
                <td colspan="16">No se encontraron datos</td>
              </tr>
              <template v-for="(prod, index) in detalleVenta">
                <tr :key="index">
                  <td>
                    {{ prod.Folio }}
                  </td>
                  <td>{{ prod.Fecha }}</td>
                  <td>{{ prod.Cliente }}</td>
                  <td>{{ prod.Cantidad }}</td>
                  <td>{{ prod.Nombre }}</td>

                  <td>
                    <b>{{ $pgsHelper.formatNumber(prod.Precio) }}</b>
                  </td>

                  <td>
                    <b>{{ prod.Moneda }}</b>
                  </td>
                </tr>
              </template>
            </tbody>
          </v-simple-table></v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogVendidosFecha" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Vendidos por fecha </v-card-title>
        <v-card-text>
          <v-btn @click="generatePdfSaleByDate()" color="red" class="mx-1 mb-2" block
            dark><v-icon>mdi-file-pdf-box</v-icon>
            Exportar a PDF
          </v-btn>
          <v-btn @click="exportExcelFecha()" color="green" class="mx-1" block dark><v-icon>mdi-file-excel-box</v-icon>
            Exportar a Excel
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialogVendidosFecha = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped></style>

<script>
import "../../assets/css/custom.css";
import "../../assets/css/sideBar.css";
import Cliente from "../../clases/Cliente.js";
import moment from "moment";
import Currency from "../../clases/Currencies.js";
import Membresia from "../../clases/Membresias/Membresia.js";
import TarifasClass from "../../clases/Tarifa.js";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import ReporteVentaProducto from "../../clases/PdfMakers/ReporteVentaProducto.js";
import ReporteVentaProductoFecha from "../../clases/PdfMakers/ReporteVentaProductoFecha.js";
import { mapGetters, mapActions } from "vuex";
import Vue from "vue";
import GenericExcelExporter from "../../clases/ExcelMaker/GeneralExcel.js";
import { queryPorTurnos } from "../../clases/FirestoreTurnos.js";
import uvDataTable from "../../components/MainComponents/DataTable.vue";
export default {
  name: "ReporteGeneral",
  components: {
    /*Select2,*/
    uvDataTable,
  },
  props: ["hideMenu"],
  data() {
    return {
      config: {
        // allowExport: true,
        // rawText: "Venta Producto",
        selectableRow: true,
        selectConfig: {
          idRowData: "Id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol: { Field: "", Type: "Asc" },
        buttons: [
          // {
          //   text: "Editar",
          //   icon: "lni lni-pencil-alt",
          //   buttonId: "editModificador",
          //   require: true,
          // },
        ],
        fields: [
          {
            text: "Nombre",
            value: "Nombre",
          },
          {
            text: "Familia",
            value: "FamiliaName",
            canBeFiltered: true,
          },
          {
            text: "Tags",
            value: "Tags",
            canBeFiltered: true,
            format: (row) => {
              const tags = Array.isArray(row.Tags) ? row.Tags.flat() : [];

              return tags
                .map(
                  (tag) => `
          <span style="
            display: inline-block;
            background-color: #1976d2;
            color: white;
            padding: 2px 10px;
            margin-right: 6px;
            margin-bottom: 4px;
            border-radius: 16px;
            font-size: 12px;
            line-height: 20px;
            white-space: nowrap;
          ">
            ${tag}
            <span style="display: none;">,</span>
          </span>
        `
                )
                .join("");
            },
          },
          {
            text: "Categoria",
            value: "CategoriaName",
            canBeFiltered: true,
          },

          {
            text: "Vendidos",
            value: "Vendidos",
          },
          {
            text: "Modificador",
            value: "ModificadoresAplicados",
            format: (row) => {
              if (row.ModificadoresAplicados) {
                let html = ""
                const modiArray = Object.entries(row.ModificadoresAplicados)
                modiArray.forEach((mod) => {
                  html +=
                    "<span>&#8226;</span> " +
                    mod[1].Cnt +
                    " " +
                    mod[1].nam +
                    " " +
                    this.$pgsHelper.formatNumber(mod[1].pco.C) + " " +
                    mod[1].pco.M +
                    "<br/>";
                })
                return html
              } else {
                return ""
              }
            },
          },
          {
            text: "Precio (Variable)",
            value: "Precio",
            format: (row) => {
              return this.$pgsHelper.formatNumber(row.Precio);
            },
          },
          {
            text: "Total Neto (descuentos incluidos)",
            value: "Total",
            format: (row) => {
              return this.$pgsHelper.formatNumber(row.Total);
            },
          },
          {
            text: "Opciones",
            value: "id",
            buttons: [
              {
                color: "green",
                text: "Detalles",
                buttonId: "detalleVenta",
                value: "Id",
              },
            ],
          },
        ],
      },

      dialogVendidosFecha: false,
      selectedProducts: [],
      selectMesero: "ALL",
      meseros: [],
      detalleVentaToogle: false,
      detalleVenta: [],
      selectTurno: "ALL",
      selectDep: "ALL",
      Horarios: [],
      orderCate: false,
      orderType: 1,
      currencyClass: Currency,
      menuFechaInicial: false,
      menuFechaInicial2: false,
      tarifas: [],
      input_familias: "ALL",
      loadingData: false,
      render: true,
      showFolios: false,
      filter: "",
      datos: {
        all: [],
        processedData: [],
      },
      input_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      input_date_final: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      selectedRes: "",
      data_clientes: [],
      tiposJuego: [],
      input_categoria: ["ALL"],
      input_caja: "",
      selectClient: "",
      input_cajero: "",
      input_folio: "",
      showModal: false,
      formKey: 0,
      data_ventas: [],
      Horario: "",
      tarifarios: [],
      data_cajas: [],
      reservations: [],
      cashiers: [],
      Categories: [],
      familias: [],
      header: [
        "Cliente",
        "Membresia",
        "Folio",
        "Familia",
        "Categoría",
        "Descripción",
        "Cantidad",
        "Total",
        "Método de pago",
        "Autorización",
        "Total",
        "Impuestos",
      ],
      processedData: [],
      aperturas: [],
    };
  },
  computed: {
    ...mapGetters(["getProductos"]),
    ...mapGetters("Categorias", ["getCategoriesFiltered"]),
    global_prod() {
      let productos = [];
      this.getProductos.forEach((element) => {
        if (
          element.Tipo != "AYB-Insumo" &&
          element.Tipo != "AYB-ICompuesto" &&
          !element.Dlat
        ) {
          productos.push(element);
        }
      });
      return productos;
    },
    possibleTags() {
      const grouped = {};

      this.global_prod.forEach(({ id, tags }) => {
        if (!tags?.length) return;
        if (!grouped[id]) grouped[id] = { prodId: id, tags: [] };
        grouped[id].tags.push(...tags);
      });

      return Object.values(grouped);
    },
    meserosComp() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.meseros;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    turnosList() {
      let dep = [
        {
          Turno: "ALL",
          Desc: "Todos",
        },
      ];
      this.aperturas.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    dataProductos() {
      if (this.filter != "") {
        return this.datos.processedData.filter((acc) =>
          acc.Nombre.toUpperCase().includes(this.filter.toUpperCase())
        );
      }
      // console.log;
      return this.datos.processedData;
    },
    categoriesList() {
      let categories = [{ id: "ALL", label: "TODOS" }];

      this.Categories.forEach((categoria) => {
        categories.push(categoria);
      });
      return categories;
    },
    familiasList() {
      let categories = [
        { id: "ALL", Nombre: "TODOS" },
        {
          id: "TRANSPORTACION",
          Nombre: "TRANSPORTACION (Sistema)",
        },
        {
          id: "EXTRA RIDER",
          Nombre: "EXTRA RIDER (Sistema) ",
        },
        {
          id: "Paquetes Rondas de Golf",
          Nombre: "Paquetes Rondas de Golf (Sistema)",
        },
      ];

      this.familias.forEach((categoria) => {
        categories.push(categoria);
      });
      return categories;
    },
    Membresias() {
      return this.$pgsHelper.indexBy(Membresia.getMembresiasList(), "Id");
    },
    selectedReserva() {
      return this.selectedRes;
    },
    comp_clients() {
      let clientes = [];
      let rowclientes = this.$pgsHelper.indexBy(Cliente.getClientsList(), "Id");
      rowclientes.forEach((cli) => {
        clientes.push({ value: cli.Id, text: cli.getNombreCompleto(), ...cli });
      });
      return clientes;
    },
    comp_totales() {
      let total = {
        Cantidad: 0,
        Descuento: 0,
        Monto: 0,
        Subtotal: 0,
        Impuestos: 0,
      };
      this.datos.processedData.forEach((prod) => {
        total.Cantidad += Number(prod.Cantidad);
        let totalMonto = Number(prod.Subtotal) + Number(prod.Impuestos);
        total.Monto += Number(totalMonto);
        total.Descuento += Number(prod.Descuento);
        total.Subtotal += Number(prod.Subtotal);
        total.Impuestos += Number(prod.Impuestos);
      });
      return total;
    },
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    filteredTableData() {
      return this.$refs.uvDataTable.retrieveData();
    },
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "detalleVenta") {
        this.showDetailVenta(idSelected);
      }
    },
    verifyDateRange() {
      /*const date1 = moment(this.input_date);
      const date2 = moment(this.input_date_final);
      const daysDifference = date2.diff(date1, 'days');
      if (daysDifference >= 45) {
        this.render = false
      } else {
        this.render = true
      }*/
    },
    exportExcel(type) {
      if (type == 0) {
        const formattedData = this.filteredTableData.map((item) => {
          return {
            Nombre: item.Id === "Reserva" ? "TEE TIMES" : item.Nombre,
            Familia: item.FamiliaName,
            Tags: item.Tags,
            Categoria: item.CategoriaName,
            Vendidos: Number(item.Vendidos),
            "Precio (Variable)": Number(item.Precio),
            "Total Neto (descuentos incluidos)": Number(item.Total),
          };
        });

        const options = {
          json_fields: {
            Nombre: "Nombre",
            Familia: "Familia",
            Tags: "Tags",
            Categoria: "Categoria",
            Vendidos: "Vendidos",
            "Precio (Variable)": "Precio (Variable)",
            "Total Neto (descuentos incluidos)":
              "Total Neto (descuentos incluidos)",
          },
        };

        GenericExcelExporter.generateExcelBuffer(formattedData, options)
          .then((buffer) => {
            const blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "Venta producto.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          })
          .catch((err) => console.error("Error exportando Excel:", err));
      } else {
        // Generamos el Excel con los datos transformados
        GenericExcelExporter.generateExcelBuffer(this.detalleVenta)
          .then((buffer) => {
            const blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "Detalle de venta producto.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          })
          .catch((err) => console.error("Error exportando Excel:", err));
      }
    },
    exportExcelFecha() {
      let grouper = [];
      this.filteredTableData.forEach((prod) => {
        let exist = this.$pgsHelper.getById(grouper, "id", prod.OriginalId);
        if (!exist) {
          grouper.push({
            id: prod.OriginalId,
            Nombre: prod.Nombre,
            grouperDate: prod.grouperDate,
          });
        } else {
          let fechasVentas = this.$pgsHelper.ArrayObjectToArray(
            prod.grouperDate
          );
          fechasVentas.forEach((fecha) => {
            if (grouper[exist.idx].grouperDate[fecha.id]) {
              grouper[exist.idx].grouperDate[fecha.id].Cantidad +=
                fecha.Cantidad;
            } else {
              grouper[exist.idx].grouperDate[fecha.id] = {
                Cantidad: fecha.Cantidad,
              };
            }
          });
        }
      });
      let dataToExcel = [];
      grouper.forEach((item) => {
        let fechasArray = this.$pgsHelper.ArrayObjectToArray(item.grouperDate);
        fechasArray.forEach((byDate) => {
          dataToExcel.push({
            Producto: item.Nombre,
            Fecha: byDate.id,
            Cantidad: byDate.Cantidad,
          });
        });
      });
      GenericExcelExporter.generateExcelBuffer(dataToExcel)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "Detalle vendidos por fecha.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => console.error("Error exportando Excel:", err));
    },
    async getMeserosAB() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Meseros"
        );
      if (snapshot.exists()) {
        this.meseros = [];
        this.meseros = this.$pgsHelper.ArrayObjectToArray(snapshot.val());
        this.meseros.forEach((mesero) => {
          let deptos = Object.entries(mesero.Deptos);
          let textDepto = "";
          deptos.forEach((depto) => {
            let testDepto = this.$pgsHelper.getById(
              this.departamentos,
              "Id",
              depto[0]
            );
            if (testDepto) {
              textDepto = textDepto + testDepto.Nombre + " ";
            }
          });
          mesero.DepartamentoText = textDepto;
        });
      }
    },
    showDetailVenta(id) {
      this.detalleVentaToogle = true;
      this.detalleVenta = [];
      this.datos.all.forEach((el) => {
        let existInSale = this.$pgsHelper.getById(el.Catalogo, "Id", id);
        if (existInSale) {
          el.Catalogo.forEach((prod) => {
            let precio = 0;
            if (prod.Pagos) {
              Object.entries(prod.Pagos).forEach((pago) => {
                precio += pago[1].def.C;
              });
            }
            let cantidad = prod.Cnt - (prod.Dto ? prod.Dto : 0);
            this.detalleVenta.push({
              Folio: el.Folio,
              Fecha: el.fecha,
              Cliente: el.Cliente.Nombre,
              Nombre: prod.Nombre,
              Cantidad: Number(cantidad),
              Precio: Number(precio),
              Moneda: prod.Moneda,
            });
          });
        }
      });
    },
    cajasList() {
      let dep = [
        {
          id: "ALL",
          Nomb: "Todos",
        },
      ];
      this.data_cajas.forEach((de) => {
        if (de.Dpto == this.selectDep) {
          dep.push(de);
        }
      });
      return dep;
    },
    async getAperturas() {
      // si el usuario cambia filtros rápido, sólo vale la última respuesta
      const request = (this._aperturasRequest = (this._aperturasRequest || 0) + 1);
      const startDate = this.input_date;
      const endDate = this.input_date_final;
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("Momento", ">=", startDate),
        firestore.where("Momento", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        //firestore.where("Caja", "==", this.$route.params.idInstalacion),
        firestore.where("Tipo", "==", "Apertura"),
      ];
      if (this.selectDep != "ALL" && this.selectDep != "") {
        filter.push(
          firestore.where("Departamentos", "array-contains", this.selectDep)
        );
      }
      const data = await firestore.queryBuilder("PDV_CierreApertura", filter);
      if (request !== this._aperturasRequest) return;
      let aperturas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      aperturas.forEach((apt) => {
        let fecha = new moment(apt.Momento, "YYYY-MM-DD_HH:mm:ss");
        let caja = this.$pgsHelper.getById(this.data_cajas, "id", apt.Caja);
        let cajeroData = this.$pgsHelper.getById(
          this.cashiers,
          "Id",
          apt.Cajero
        );
        apt.CajaData = caja;
        apt.CajeroData = cajeroData;
        apt.Desc =
          "Turno Fecha " +
          fecha.format("DD-MM-YYYY") +
          " Hora: " +
          fecha.format("HH:mm") +
          " || " +
          caja.Nomb +
          " || " +
          cajeroData.Nomb +
          " || Turno: " +
          apt.Turno;
      });

      this.aperturas = aperturas;
    },
    generatePdf() {
      let mainData = {
        FI: this.input_date,
        FF: this.input_date_final,
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        data: this.filteredTableData,
      };
      let docData = ReporteVentaProducto.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    generatePdfSaleByDate() {
      let mainData = {
        FI: this.input_date,
        FF: this.input_date_final,
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        data: this.filteredTableData,
      };
      let docData = ReporteVentaProductoFecha.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    async getTiposJuego() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Tarifas/Golf/Modalidades"
        );
      if (!data.exists()) {
        return false;
      }
      let arrayTipos = Object.entries(data.val());
      var $this = this;
      arrayTipos.forEach((element) => {
        $this.tiposJuego.push({
          id: element[0],
          codigo: element[1]["Codigo"],
          nombre: element[1]["Nombre"],
        });
      });
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      await this.fetchCategories();
      const claims = this.$route.params?.user?.tokenResult?.claims;
      const cats = this.getCategoriesFiltered(claims);
      this.Categories = [{ id: "GREENFEE", label: "GREEN FEE" }, ...cats];
    },
    processVentas() {
      console.time("ProcessVentas");

      let productosSum = {};
      let productosGlobalQuantity = {};
      // índices por id, armados una vez por búsqueda (antes: getById/find
      // lineales por cada línea de venta)
      const tiposJuegoMap = new Map(this.tiposJuego.map((t) => [t.id, t]));
      const horariosMap = new Map(this.Horarios.map((h) => [h.id, h]));
      const tarifariosMap = new Map(this.tarifarios.map((t) => [t.Id, t]));
      const tagsMap = new Map(this.possibleTags.map((t) => [t.prodId, t]));
      this.datos.all.forEach((el) => {
        el.Catalogo.forEach((prod) => {
          try {
            let precio = 0;
            if (prod.Pagos) {
              Object.entries(prod.Pagos).forEach((pago) => {
                precio += pago[1].def.C;
              });
            }
            let cantidad = prod.Cnt - (prod.Dto ? prod.Dto : 0);
            let indetPrice = precio > 0 ? precio / cantidad : 0;
            let process = true;
            if (this.selectMesero != "ALL") {
              if (prod.ExtraParams?.AYB?.Mesero == this.selectMesero) {
                process = true;
              } else {
                process = false;
              }
            }

            if ((cantidad > 0) & process) {
              prod.OriginalId = prod.Id;
              prod.Id = prod.Id + "-" + indetPrice;
              if (prod.Id.includes("Reserva")) {
                prod.Nombre = "GREEN FEE";

                prod.OriginalId = prod.Id;
                prod.Categoria.N = "GREEN FEE";
                prod.Categoria.N = "GREEN FEE";
                if (prod.Orn != "Golf") {
                  prod.Familia.N = prod.Orn;
                  prod.Familia.I = prod.Orn;
                  prod.Categoria.N = prod.Orn;
                }
                let Catalogo = prod.Catalogo[0];
                let ExtraParams = Catalogo ? Catalogo.ExtraParams : false;
                let tarifaId = Catalogo.Id
                console.log(Catalogo)
                let tarifaData = ExtraParams.TarifaData;
                //
                if (Catalogo.Tip == "Serie") {
                  prod.Nombre = prod.Nombre + " PREPAGADO " + Catalogo.Nombre;
                }

                let subTarifa = "";
                if (tarifaData) {
                  let tarifarioId = tarifaData.Tar;
                  let Mod = tarifaData.Mod;
                  let Hor = tarifaData.Hor;
                  let SubNom = tarifaData.SubN;
                  let tipoJuego = tiposJuegoMap.get(Mod);
                  let horario = horariosMap.get(Hor);
                  let tarifa = tarifariosMap.get(tarifarioId);

                  if (tarifaData.Tur) {
                    prod.Tur = tarifaData.Tur;
                  }

                  if (tarifaData.MerN) {
                    prod.MerN = tarifaData.MerN;
                  } else {
                    let tarifaSnaphot = this.tarifas.find(o => o.Id == tarifaId || o.id == tarifaId);
                    prod.Mer = tarifaData.Mer || tarifaSnaphot?.Mercado;

                  }

                  if (tarifa) {
                    prod.Nombre = prod.Nombre + " " + tarifa.text;
                  }
                  if (SubNom) {
                    subTarifa = SubNom;
                    prod.Nombre = prod.Nombre + " " + SubNom;
                  }
                  if (horario) {
                    prod.Nombre = prod.Nombre + " " + horario.NombreCompleto;
                  }
                  if (tipoJuego) {
                    prod.Nombre = prod.Nombre + " " + tipoJuego.nombre;
                  }
                }
                prod.Id =
                  prod.Id +
                  "-" +
                  prod.Categoria.I +
                  "-" +
                  tarifaData.Tar +
                  subTarifa;
              }
              if (prod.Id.includes("RVA-ExtraRidder")) {
                prod.Nombre = "Extra rider";
                prod.Categoria.N = "EXTRA RIDER";
                prod.Categoria.I = "EXTRA RIDER";
                prod.Familia.N = "EXTRA RIDER";
                prod.Familia.I = "EXTRA RIDER";
              }

              if (prod.Id.includes("RVA-Transportacion")) {
                prod.Nombre = "Transportacion";
                prod.Categoria.N = "TRANSPORTACION";
                prod.Categoria.I = "TRANSPORTACION";
                prod.Familia.N = "TRANSPORTACION";
                prod.Familia.I = "TRANSPORTACION";
              }

              if (prod.Tip == "Cupon") {
                prod.Categoria.N = "Paquetes Rondas de Golf";
                prod.Categoria.I = "Paquetes Rondas de Golf";
                prod.Familia.N = "Paquetes Rondas de Golf";
                prod.Familia.I = "Paquetes Rondas de Golf";
              }

              let cntpagos = Object.entries(prod.Pagos).reduce(
                (acum, curr) => acum + curr[1].cnt,
                0
              );

              if (!productosSum[prod.Id]) {
                /*if(prod.Modificadores){
                prod.ModificadoresList = Modificadores.parseToListOption(prod.Modificadores)
                  let totalModi = 0;
                  prod.ModificadoresList.forEach((modi)=>{
                    totalModi += modi.pco.C
                  })
                  venta.Catalogo[property].totalModi = totalModi
              }*/

                /*prod.Id = prod.Id + ' '+prod.Categoria.I
                prod.Nombre = "TEE TIME"*/
                let grouperDate = {};
                grouperDate[el.FechaVenta] = { Cantidad: cantidad };

                const tag = tagsMap.get(prod.OriginalId);

                productosSum[prod.Id] = {
                  OriginalId: prod.OriginalId,
                  Categoria: prod.Categoria.I,
                  CategoriaName: prod.Categoria.N,
                  Familia: prod.Familia.I,
                  FamiliaName: prod.Familia.N,
                  Nombre: prod.Nombre,
                  Tickets: [el.Folio],
                  Vendidos: cantidad,
                  Precio: precio > 0 ? precio / cantidad : 0,
                  Total: Number(precio),
                  Diff: cantidad - cntpagos,
                  grouperDate: grouperDate,
                  Tur: prod.Tur,
                  MerN: prod.MerN,
                  Mer: prod.Mer,
                  Tags: tag ? [tag.tags] : [],
                };

              } else {
                productosSum[prod.Id].Vendidos =
                  productosSum[prod.Id].Vendidos + cantidad;
                productosSum[prod.Id].Total =
                  productosSum[prod.Id].Total + Number(precio);
                productosSum[prod.Id].Diff += Number(
                  cantidad - Math.round(cntpagos)
                );
                if (!productosSum[prod.Id].grouperDate[el.FechaVenta]) {
                  productosSum[prod.Id].grouperDate[el.FechaVenta] = {
                    Cantidad: cantidad,
                  };
                } else {
                  productosSum[prod.Id].grouperDate[el.FechaVenta].Cantidad +=
                    cantidad;
                }
                productosSum[prod.Id].Tickets.push(el.Folio);
                if (!productosSum[prod.Id].Mer && prod.Mer) {
                  productosSum[prod.Id].Mer = prod.Mer;
                }
                if (!productosSum[prod.Id].MerN && prod.MerN) {
                  productosSum[prod.Id].MerN = prod.MerN;
                }
              }
              ///agregamos a la sumatoria total de los productos
              if (!productosGlobalQuantity[prod.OriginalId]) {
                productosGlobalQuantity[prod.OriginalId] = cantidad;
              } else {
                productosGlobalQuantity[prod.OriginalId] += cantidad;
              }

              if (prod.Modificadores) {
                if (!productosSum[prod.Id].ModificadoresAplicados) {
                  productosSum[prod.Id].ModificadoresAplicados = {}
                }

                prod.Modificadores.forEach((mod) => {
                  mod.sel.forEach((selection) => {


                    if (!productosSum[prod.Id].ModificadoresAplicados[mod.Id + "-" + selection.idx]) {
                      productosSum[prod.Id].ModificadoresAplicados[mod.Id + "-" + selection.idx] = this.$pgsHelper.cloneObj(selection)
                      productosSum[prod.Id].ModificadoresAplicados[mod.Id + "-" + selection.idx].Cnt = (selection.Cnt * cantidad)

                      productosSum[prod.Id].ModificadoresAplicados[mod.Id + "-" + selection.idx].baseData = ("-" + selection.Cnt)
                    } else {
                      productosSum[prod.Id].ModificadoresAplicados[mod.Id + "-" + selection.idx].Cnt = productosSum[prod.Id].ModificadoresAplicados[mod.Id + "-" + selection.idx].Cnt + (selection.Cnt * cantidad)
                      productosSum[prod.Id].ModificadoresAplicados[mod.Id + "-" + selection.idx].baseData += ("-" + selection.Cnt)
                    }

                  })
                })
              }
            }
          } catch (e) {
            console.log(e);
          }
        });
      });
      let preData = Object.entries(productosSum);
      let arrayData = [];
      preData.forEach((data) => {
        data[1].TotalGeneral = productosGlobalQuantity[data[1].OriginalId]
        if (this.input_familias != "ALL") {
          if (!this.input_categoria.includes("ALL")) {
            if (
              this.input_categoria.includes(data[1].Categoria) &&
              this.input_familias == data[1].Familia
            ) {
              arrayData.push({ Id: data[0], ...data[1] });
            }
            if (
              this.input_categoria.includes("GREENFEE") &&
              data[0].includes("Reserva")
            ) {
              arrayData.push({ Id: data[0], ...data[1] });
            }
          } else {
            if (this.input_familias == data[1].Familia) {
              arrayData.push({ Id: data[0], ...data[1] });
            }
          }
        } else {
          if (!this.input_categoria.includes("ALL")) {
            if (this.input_categoria.includes(data[1].Categoria)) {
              arrayData.push({ Id: data[0], ...data[1] });
            }
            if (
              this.input_categoria.includes("GREENFEE") &&
              data[0].includes("Reserva")
            ) {
              arrayData.push({ Id: data[0], ...data[1] });
            }
          } else {
            arrayData.push({ Id: data[0], ...data[1] });
          }
        }
      });
      if (this.orderType == 2) {
        arrayData = this.$_.orderBy(
          arrayData,
          ["Categoria", "Vendidos"],
          ["desc", "desc"]
        );
      } else if (this.orderType == 1) {
        arrayData = this.$_.orderBy(arrayData, ["TotalGeneral", "Nombre", "Vendidos"], ["desc", "asc", "desc"]);
      } else if (this.orderType == 3) {
        arrayData = this.$_.orderBy(
          arrayData,
          ["Nombre", "Vendidos"],
          ["asc", "desc"]
        );
      }

      if (this.selectedProducts.length > 0) {
        arrayData = arrayData.filter((item) =>
          this.selectedProducts.includes(item.OriginalId)
        );
      }
      // congelado: Vue 2 no observa en profundidad grouperDate/Tickets/etc.;
      // la tabla sólo lee, filtra y pagina estas filas
      this.datos.processedData = Object.freeze(arrayData);
      console.timeEnd("ProcessVentas");
    },
    async getComboTarifarios() {
      /* obtiene el listado de tarifas para armado del comboBox */
      let tarifarios = await TarifasClass.getMixTarifasCombo("Golf");
      tarifarios.forEach((element) => {
        element.value = element.Id;
        element.text = element.Nombre;
      });
      this.tarifarios = tarifarios;
    },
    async getTarifas() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ];
      const data = await firestore.queryBuilder("RVA_Tarifas", filter);
      let tar = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      tar.forEach((tarifaData) => {
        let arrayPrecios = [];
        let arrayDays = Object.entries(tarifaData.Precios);
        arrayDays.forEach((mod) => {
          let modDias = mod[0].split("-");
          let textDias = "";
          modDias.forEach((element) => {
            textDias += " " + this.$pgsHelper.getDayName(element, "Simple");
          });
          let arrayModalidades = Object.entries(mod[1]);
          arrayModalidades.forEach((modalidad) => {
            let dataModalidades = {
              id: modalidad[0],
              textDias: textDias,
              dias: modDias,
              horarios: [],
            };
            let arrayHorarios = Object.entries(modalidad[1]);
            arrayHorarios.forEach((horario) => {
              let dataHorarios = {
                id: horario[0],
                ...horario[1],
              };
              dataModalidades.horarios.push(dataHorarios);
            });
            arrayPrecios.push(dataModalidades);
          });

          tarifaData.arrayPrecios = arrayPrecios;
        });
      });
      this.tarifas = tar;
    },
    cleanFilter() {
      this.input_date = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.input_date_final = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.input_folio = "";
      this.selectClient = "";
      this.selectDep = "ALL";
      this.selectedProducts = []
      this.input_categoria = []
    },
    showDetail(res) {
      this.selectedRes = res;
      if (this.selectedRes) {
        let prod = Object.entries(this.selectedRes.Catalogo);
        this.selectedRes.ListProducts = prod;
        let pag = Object.entries(this.selectedRes.Pagos);
        this.selectedRes.ListPagos = pag;
      } else {
        this.selectedRes.ListProducts = [];
      }
      this.showModal = true;
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    async getCajas() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajas"
        );
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getCashiers() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajeros"
        );

      if (snapshot.exists()) {
        this.cashiers = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cashiers.push(toAdd);
          }
        });
      }
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getHorarios() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Tarifas/Golf/Horarios"
        );

      if (!data.exists()) {
        return false;
      }
      let arrayHorarios = Object.entries(data.val());
      var $this = this;
      arrayHorarios.forEach(function (element) {
        $this.Horarios.push({
          id: element[0],
          NombreCompleto: element[1].Nombre,
          ...element[1],
        });
      });
    },
    async getVentas() {
      let turnos = [];
      if (this.selectTurno != "ALL") {
        turnos.push(this.selectTurno);
      } else {
        this.aperturas.forEach((de) => {
          turnos.push(de.Turno);
        });
      }

      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ];

      if (this.selectDep != "ALL") {
        filter.push(firestore.where("Departamento", "==", this.selectDep));
      }

      if (this.input_folio != "") {
        filter.push(firestore.where("Folio", "==", this.input_folio));
      }

      if (this.selectClient != "") {
        filter.push(firestore.where("Cliente.Id", "==", this.selectClient));
      }

      // una query por bloque de 30 turnos en vez de una por turno
      let listVentas = await queryPorTurnos(
        firestore,
        "PDV_Ventas",
        turnos,
        filter
      );

      listVentas.forEach((item) => {
        item.fecha = new moment(item.FechaCreacion).format("YYYY-MM-DD HH:mm");
      });

      listVentas = this.$_.orderBy(listVentas, "fecha", "desc");

      // se congela el arreglo: Vue 2 no observa en profundidad miles de
      // ventas (processVentas sigue mutando los productos igual que antes)
      this.datos.all = Object.freeze(listVentas);
    },
    async getFamilias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Familias"
        );

      this.familias = [];
      this.familias = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async searchVentas() {
      this.verifyDateRange();
      // el overlay se mantiene durante processVentas (síncrono y pesado)
      this.loadingData = true;
      try {
        await this.getVentas();
        await this.$nextTick();
        // cede el hilo para que el overlay se pinte antes de procesar
        await new Promise((resolve) => setTimeout(resolve, 0));
        this.processVentas();
      } catch (err) {
        console.error("Error cargando ventas por producto:", err);
      } finally {
        this.loadingData = false;
      }
    },
  },
  beforeCreate: function () { },
  beforeMount: async function () {
    this.$store.dispatch("TarifasStore/getMercadosReserva");
    this.getMeserosAB();
    this.getTarifas();
    this.getCategories();
    this.getFamilias();
    this.getTiposJuego();
    this.getHorarios();
    this.getComboTarifarios();
    //this.tarifas = await TarifasClass.getMixTarifasByDep("Golf");
    // las descripciones de turno usan cajas y cajeros: cargarlos primero
    Promise.allSettled([this.getCajas(), this.getCashiers()]).then(() =>
      this.getAperturas()
    );
    this.$emit("useNav", true);
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>
